import BaseReporter from './BaseReporter';
import { getCounts, incrementTransitionCount, installGraniteHealthPatches } from '../GraniteHealthPatches';
import { GraniteHealthMetrics } from '../Metrics';
import { maybeGetReferrerApp } from '../appTransitionHistory';
export default class GraniteHealthReporter extends BaseReporter {
  constructor(options) {
    super(options);
    this.fired = false;
    installGraniteHealthPatches();
  }
  report(action) {
    const softNavCtx = this.softNavigationContext;
    if (this.fired || !softNavCtx || action.type !== 'ROUTE_SUCCEEDED') {
      return;
    }
    this.fired = true;
    incrementTransitionCount();
    const {
      listenerCount,
      timerCount,
      observerCount,
      transitionCount
    } = getCounts();
    const referrerApp = maybeGetReferrerApp(softNavCtx);
    const dimensions = Object.assign({
      transition: String(Math.min(transitionCount, 20))
    }, referrerApp !== null && {
      referrerApp
    });
    GraniteHealthMetrics.histogram('stylesheet-count', dimensions).update(document.styleSheets.length);
    GraniteHealthMetrics.histogram('listener-count', dimensions).update(listenerCount);
    GraniteHealthMetrics.histogram('timer-count', dimensions).update(timerCount);
    GraniteHealthMetrics.histogram('observer-count', dimensions).update(observerCount);
  }
}